export default __webpack_public_path__ + "static/media/portafolios.a1bcd722.png";